import { render, staticRenderFns } from "./CertificateDashboard.vue?vue&type=template&id=98f73ada&scoped=true"
import script from "./CertificateDashboard.vue?vue&type=script&lang=js"
export * from "./CertificateDashboard.vue?vue&type=script&lang=js"
import style0 from "./CertificateDashboard.vue?vue&type=style&index=0&id=98f73ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f73ada",
  null
  
)

export default component.exports